<template>
  <div class="d-none d-md-block" style="margin-bottom:70px;">
    <v-app-bar fixed :height="75">
      <div class style="width:30%">
        <v-toolbar-title class="logofont">
          <router-link to="/" class="nolink">
            <span class="primary--text">Why</span>
            <span class="secondary--text">Buy</span>
          </router-link>
        </v-toolbar-title>
      </div>

      <v-toolbar-items style="width:60%;justify-content: center;">
        <v-btn text small @click="goSearch" style="width:100px">
          <div class="text-center">
            <v-icon class="mb-1">fa-search</v-icon>
            <br />
            <span class="font-weight-bold">Search</span>
          </div>
        </v-btn>

        <v-btn text to="/about" small style="width:100px">
          <div class="text-center">
            <img style="height:25px;width:28px" class src="/logo.png" />
            <br />
            <span class="font-weight-bold">About Us</span>
          </div>
        </v-btn>

        <v-btn text small to="/contests" style="width:100px">
          <div class="text-center">
            <v-icon class="mb-1">fa-gift</v-icon>
            <br />
            <span class="font-weight-bold">Contests</span>
          </div>
        </v-btn>

        <v-btn
          text
          small
          to="/user/progress"
          v-if="$store.getters['account/type'] === 'user'"
          style="width:100px"
        >
          <div :class="`text-center rank-star rank-${$store.state.account.account.rank}-star`">
            <v-icon class="mb-1">fa-star</v-icon>
            <br />
            <span class="font-weight-bold">My Progress</span>
          </div>
        </v-btn>

        <v-btn
          text
          small
          to="/user/projects/create"
          v-if="$store.getters['account/type'] === 'user'"
          style="width:100px"
        >
          <div class="text-center">
            <v-icon class="mb-1" color="green">fa-plus-circle</v-icon>
            <br />
            <span class="font-weight-bold">New Project</span>
          </div>
        </v-btn>

        <v-btn
          text
          small
          @click="createContest"
          v-if="$store.getters['account/type'] === 'business'"
          style="width:100px"
        >
          <div class="text-center">
            <v-icon class="mb-1" color="green">fa-plus-circle</v-icon>
            <br />
            <span class="font-weight-bold">New Contest</span>
          </div>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items style="width:30%;justify-content:flex-end">
        <v-btn
          text
          small
          @click="openNewsletter"
          v-if="!$store.getters['account/isLoggedIn']"
          style="width:120px"
        >
          <div class="text-center">
            <v-badge>
              <template v-slot:badge v-if="newsLetterBell">1</template>
              <v-icon class="mb-1">fa-bell</v-icon>
            </v-badge>
            <br />
            <span class="font-weight-bold">Notifications</span>
          </div>
        </v-btn>

        <v-menu
          v-model="notifications_menu"
          offset-y
          v-if="$store.getters['account/isLoggedIn']"
          :min-width="400"
        >
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" style="width:120px">
              <div class="text-center">
                <v-badge>
                  <template
                    v-slot:badge
                    v-if="$store.getters['notifications/count']"
                  >{{$store.getters['notifications/count']}}</template>
                  <v-icon class="mb-1">fa-bell</v-icon>
                </v-badge>
                <br />
                <span class="font-weight-bold">Notifications</span>
              </div>
            </v-btn>
          </template>

          <v-card v-if="$store.state.notifications.notifications.length">
            <v-card-title class="secondary white--text">
              <h5>Notifications</h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-list two-line class="pa-0" style="max-height:325px;overflow-y:scroll">
              <v-list-item-group v-model="selected">
                <template v-for="(item, index) in $store.getters['notifications/sorted']">
                  <v-list-item
                    :key="index"
                    :to="item.link ? item.link : null"
                    :class="item.seen ? '' : 'new_notification'"
                  >
                    <template v-slot:default="{  }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.text"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-list-item-action-text>{{item.date_added | fromNow}}</v-list-item-action-text>
                        <v-icon v-if="item.seen==0" color="primary">fas fa-blank</v-icon>
                        <v-icon v-else>fa-blank</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-divider
                    style
                    v-if="index + 1 < $store.state.notifications.notifications.length"
                    :key="'d' + index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
            <v-card-actions class="grey lighten-3">
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                text
                v-if="$store.state.notifications.notifications.length"
                @click="$store.dispatch('notifications/clear')"
              >Clear</v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-else>
            <v-card-text>You have no new notifications</v-card-text>
          </v-card>
        </v-menu>

        <v-btn text small to="/access" v-if="!$store.getters['account/isLoggedIn']">
          <div class="text-center">
            <v-icon class="mb-1">fa-user</v-icon>
            <br />
            <span class="font-weight-bold">Sign In</span>
          </div>
        </v-btn>

        <v-btn to="/admin" text small v-if="$store.getters['account/type'] === 'admin' ">
          <div class="text-center">
            <v-icon class="mb-1">fa-user</v-icon>
            <br />
            <span class="font-weight-bold">Admin</span>
          </div>
        </v-btn>

        <v-menu
          offset-y
          v-if="$store.getters['account/type'] === 'user' || $store.getters['account/type'] === 'business'"
          :min-width="240"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small>
              <div class="text-center">
                <v-icon class="mb-1">fa-user</v-icon>
                <br />
                <span class="font-weight-bold">Account</span>
              </div>
            </v-btn>
          </template>

          <v-list class="py-0">
            <v-list-item to="/user/profile" v-if="$store.getters['account/type'] === 'user' ">
              <v-list-item-icon>
                <v-icon>fa-id-badge</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-text="'Profile'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/user/projects" exact v-if="$store.getters['account/type'] === 'user'">
              <v-list-item-icon>
                <v-icon>fa-film</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-text="'My Projects'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              to="/business/profile"
              v-if="$store.getters['account/type'] === 'business'"
            >
              <v-list-item-icon>
                <v-icon>fa-id-badge</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-text="'Profile'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/user/wallet" v-if="$store.getters['account/type'] === 'user'">
              <v-list-item-icon>
                <v-icon>fa-wallet</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-text="'Wallet'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item @click="$store.commit('account/logout')" class>
              <v-list-item-icon>
                <v-icon>fa-walking</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold" v-text="'Sign Out'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  name: "",
  data: () => ({
    newsletter_prompted: false,
    selected: "",
    notifications_menu: false
  }),
  watch: {
    selected: function() {
      this.$store.dispatch("notifications/seen_all");
    },
    notifications_menu: function(to) {
      if (to === false) {
        this.$store.dispatch("notifications/seen_all");
      }
    }
  },
  computed: {
    newsLetterBell() {
      if (this.newsletter_prompted) {
        return null;
      }
      if (localStorage.getItem("newsletter_prompted")) {
        return null;
      }
      return 1;
    }
  },
  methods: {
    createContest() {
      this.$eventBus.$emit("create_contest");
    },
    openNotifications: function() {
      this.$eventBus.$emit("show_notifications");
    },
    openNewsletter: function() {
      localStorage.setItem("newsletter_prompted", new Date().getTime());
      this.newsletter_prompted = true;
      this.$eventBus.$emit("show_newsletter");
    },
    goSearch: function() {
      if (this.$route.name === "PublicProjects") {
        this.$store.commit("projects/show_search");
        setTimeout(
          function() {
            this.$vuetify.goTo("#search", {
              duration: 300,
              offset: 75,
              easing: "easeInOutCubic"
            });
          }.bind(this),
          100
        );
      } else {
        this.$router.push("/#search");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn--active::before {
  opacity: 0;
}
@font-face {
  font-family: "Arial Rounded MT Bold";
  src: url("/fonts/ArialRoundedMTBold.ttf"),
    url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 32px;
  letter-spacing: -2px;
}
.new_notification {
  border-left: 5px solid #ff5744;
}
.ring {
  animation-name: ringing;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in;
}
/* Safari 4.0 - 8.0 */
@-webkit-keyframes ringing {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  20% {
    transform: rotate(20deg);
  }
  30% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(-20deg);
  }
  70% {
    transform: rotate(-10deg);
  }
  80% {
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

/* Standard syntax */
@keyframes ringing {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  20% {
    transform: rotate(20deg);
  }
  30% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(-20deg);
  }
  70% {
    transform: rotate(-10deg);
  }
  80% {
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
